import { cn } from '../../lib/cn';
import type { AgentConfigRow } from '../../automationstudio/framework';

type Props = { configs?: AgentConfigRow[] };

export function AgentBuilderPanel({ configs = [] }: Props) {
  return (
    <div className="space-y-2">
      {configs.map((c) => (
        <div key={c.name} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-start justify-between gap-3">
            <p className="text-sm font-medium">{c.name}</p>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              c.mode === 'autonomous' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' : 'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300',
            )}>
              {c.mode}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">
            {c.capabilities} capabilities · {c.tools} tools · scope: {c.scope}
          </p>
        </div>
      ))}
    </div>
  );
}
